import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { JobRole } from 'src/app/model/admin/job-role';

@Injectable({
  providedIn: 'root',
})
export class JobRoleTableService extends BaseTableService<JobRole> {
  constructor() {
    super();
  }
}
